<template>
  <div class="select-box"
       v-click-outside="setDisabled">
    <div class="select-box__select-area"
         @click="selectToggle">
      <span v-if="selectedValue"
            class="select-box__selected-value">
        {{ selectedValue }}
      </span>
      <span v-else
            class="select-box__placeholder">
        {{ placeholder }}
      </span>
      <div class="select-box__icon-holder">
        <icon :name="getArrowName"
              :width="26"
              color="grey"></icon>
      </div>
    </div>

    <div class="select-box__list-holder"
         v-if="isOpen && !isEmptyMethodList">
      <ul class="select-box__list-items">
        <li class="select-box__list-item "
            v-for="item in items" :key="getItemLabel(item)"
            @click="setMethodItem(item)">
          <span>{{ getItemLabel(item) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import ClickOutside from '../../directives/ClickOutside'
  import Icon from '../icon/Icon'

  export default {
    name: 'select-box',
    components: {
      Icon
    },
    props: {
      placeholder: {
        type: String,
        default: 'Zeige alles'
      },
      itemKey: {
        type: String,
        default: 'name'
      },
      items: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data() {
      return {
        selectedValue: '',
        isOpen: false
      };
    },
    computed: {
      isEmptyMethodList () {
        return this.items.length === 0;
      },
      getArrowName () {
        return this.isOpen ? 'arrow-up' : 'arrow-down';
      }
    },
    methods: {
      getItemLabel(item) {
        return item[this.itemKey] || item;
      },
      setMethodItem(item) {
        this.selectedValue = this.getItemLabel(item);

        this.$emit('select', item);

        this.setDisabled();
      },
      setActive() {
        this.isOpen = true;
      },
      setDisabled() {
        this.isOpen = false;
      },
      selectToggle() {
        this.isOpen = !this.isOpen;
      }
    },
    directives: {
      ClickOutside
    }
  }
</script>

<style lang="less">
  @import "../../less/variables.less";

  .select-box {
      position: relative;
      z-index: 15;
      background: white;
      border: 1px solid @light-grey;
      min-height: 58px;

      &__icon-holder {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          width: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
      }

      &__select-area {
          position: relative;
          z-index: 10;
          border: 0;
          padding: 17px 40px 17px 17px;
          font-size: 1.125rem;
          line-height: 1.5rem;
          color: @black-grey;
          background-color: transparent;
          box-sizing: border-box;
          cursor: pointer;

          &:focus {
              outline: none;
          }
      }
  
      &__placeholder {
         color: @grey;
      }

      &__list-holder {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          margin: 1px -1px 0 -1px;
          background: white;
          border: 1px solid @light-grey;
          border-top: 0;
          z-index: 10;
      }

      &__list-items {
          padding: 0;
          margin: 0;
          list-style: none;
          font-size: 1.125rem;
          line-height: 1.5rem;
          color: @black;
      }

      &__list-item {
          padding: 12px 17px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;

          &:hover,
          &:active {
              background: @secondary;
              color: white;
          }
      }

      @media screen and (max-width: 768px) {
          min-height: 42px;

          &__icon-holder {
              width: 30px;
          }

          &__select-area {
              padding: 12px 30px 12px 13px;
              font-size: 0.875rem;
              line-height: 1.125rem;
          }

          &__list-items {
              font-size: 0.875rem;
              line-height: 1rem;
          }

          &__list-item {
             padding: 12px 13px;
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/select-box/SelectBox.vue